import React, { useState, useEffect, useCallback } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { SelectButton } from "primereact/selectbutton";
import { Alert, Button, Card, CardBody, CardHeader, Col, Form, Row } from "reactstrap";
import moment from "moment";
import { httpClient } from "../../../api/httpClient";
import { urlCalcularRenovaciones, urlGuardarRenovaciones, urlObtenerSiniestralidad } from "../api/urls";
import ConfirmDialog from "../../../components/Compras/ConfirmDialog";
import { validarBotonRenovar } from "../redux/aRenovaciones";
import { RAMO_ENUM } from "../constants/ramosEnums";
import { Checkbox } from "react-inputs-validation";

const ValoresRenovacion = (props) => {
  const {
    dataRenovacion,
    producto,
    setLoading,
    history,
    dataUsuario,
    paso,
    codigoProductoEspecial,
    codeProductoEspecial,
    disabled,
    validarFormulario,
    valoresTotales
  } = props;
  const [errorCalular, setErrorCalular] = useState(false);
  const [mensajeErrorCalcular, setMensajeErrorCalcular] = useState('');
  const [errorRenovaciones, setErrorRenovaciones] = useState(false);
  const [mensajeErrorRenovaciones, setMensajeErrorRenovaciones] = useState('');
  const [isConfirmOpen, setIsConfirmOpen] = useState(false);
  const [message, setMessage] = useState('');
  const [confirmAction, setConfirmAction] = useState(null);
  const [terminosHabilitado, setTerminosHabilitado] = useState(false);

  // Totales State
  const [total, setTotal] = useState({
    primaNeta: 0,
    prima_neta_anual_full_cobertura: 0,
    super_bancos_Full_Cobertura: 0,
    seguro_campesino_Full_Cobertura: 0,
    derecho_emision_Full_Cobertura: 0,
    primaTotal_Full_Cobertura: 0,
    iva_Full_Cobertura: 0,
    totalImpuestos: 0,
  });

  const ramoSeguro = (dataRenovacion && dataRenovacion.ramo) ||
    (dataRenovacion && dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamoProducto === 'PYMES' ? 'PYMES' : (dataRenovacion && dataRenovacion.reDatosProducto && dataRenovacion.reDatosProducto.reRamo)) || "";
  const esPymes = ramoSeguro === RAMO_ENUM.PYMES;

  // Helpers
  const esFullCobertura = useCallback(() => {
    let esFull = true;
    let vehiculos = (dataRenovacion && dataRenovacion.vehiculoAll) || [];
    vehiculos.forEach(vehiculo => {
      if (vehiculo.rePlanSeleccionado !== 'fullCobertura') {
        esFull = false;
      }
    });
    return esFull;
  }, [dataRenovacion]);

  const obtenerPlanes = useCallback(() => {
    if (esPymes) return [];
    if (dataRenovacion && dataRenovacion.productoExterno) return [{ codigo: "", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "", valor: 0, valorImpuestos: "20.84" }];
    if (producto === 'PRACTIAUTO' || producto === 'PRACTI AUTO') {
      return [{ codigo: "PRACTIAUTO", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "PRACTIAUTO", valor: parseFloat(dataRenovacion.total) + 75, valorImpuestos: "20.84" }];
    }
    if (!esFullCobertura()) {
      return [{ codigo: "AIGAUTO", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "AIG AUTO", valor: dataRenovacion.total, valorImpuestos: "20.84" }];
    }
    return [
      { codigo: "AIGAUTO", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "AIG AUTO", valor: dataRenovacion.total, valorImpuestos: "20.84" },
      { codigo: "PRACTIAUTO", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "PRACTIAUTO", valor: parseFloat(dataRenovacion.total) + 75, valorImpuestos: "20.84" }
    ];
  }, [dataRenovacion, producto, esFullCobertura]);

  const obtenerPlanSeleccionado = useCallback(() => {
    if (esPymes) return null;
    if (dataRenovacion && dataRenovacion.productoExterno) return { codigo: "", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "", valor: 0, valorImpuestos: "20.84" };
    if (producto === 'PRACTIAUTO' || producto === 'PRACTI AUTO') {
      return { codigo: "PRACTIAUTO", vigenciaMeses: "3 meses", vigenciaDias: "", plan: "PRACTIAUTO", valor: parseFloat(dataRenovacion.total) + 75, valorImpuestos: "20.84" };
    }
    return { codigo: "AIGAUTO", vigenciaMeses: "3 meses", vigenciaDias: "90 días", plan: "AIG AUTO", valor: dataRenovacion.total, valorImpuestos: "20.84" };
  }, [dataRenovacion, producto]);

  const [planes] = useState(obtenerPlanes());
  const [planSeleccionado, setPlanSeleccionado] = useState(obtenerPlanSeleccionado());

  const sumarValoresTotales = (data) => {
    const keysToSum = ["primaNeta", "prima_neta_anual_full_cobertura", "super_bancos_Full_Cobertura", "seguro_campesino_Full_Cobertura", "derecho_emision_Full_Cobertura", "iva_Full_Cobertura", "primaTotal_Full_Cobertura", "totalImpuestos"];
    let resultado = {};
    keysToSum.forEach(key => resultado[key] = 0);
    data.forEach(item => {
      if (Array.isArray(item.valoresTotales)) {
        item.valoresTotales.forEach(valor => {
          keysToSum.forEach(key => {
            if (valor[key] !== undefined) {
              resultado[key] += valor[key];
            }
          });
        });
      }
    });
    return resultado;
  };

  const calcularTotales = useCallback(async (codigoPlan) => {
    if (setLoading && typeof setLoading === 'function') {
      setLoading(true);
    }
    try {
      const url = `${urlCalcularRenovaciones}&idRenovacion=${dataRenovacion._id}&tipoPoliza=${codigoPlan} `;
      const data = await httpClient.get(url);

      // --- INICIO CAPA TEMPORAL PYMES ---
      if (esPymes) {
        let pymesData = Array.isArray(data) ? data[0] : data;
        if (pymesData) {
          setTotal({
            primaNeta: pymesData.primaNeta || 0,
            prima_neta_anual_full_cobertura: pymesData.prima_neta_anual_full_cobertura || 0,
            super_bancos_Full_Cobertura: pymesData.super_bancos_Full_Cobertura || 0,
            seguro_campesino_Full_Cobertura: pymesData.seguro_campesino_Full_Cobertura || 0,
            derecho_emision_Full_Cobertura: pymesData.derecho_emision_Full_Cobertura || 0,
            iva_Full_Cobertura: pymesData.iva_Full_Cobertura || 0,
            primaTotal_Full_Cobertura: pymesData.primaTotal_Full_Cobertura || 0,
            totalImpuestos: pymesData.totalImpuestos || 0,
          });
          setErrorCalular(false);
          setMensajeErrorCalcular('');
        }
        return;
      }
      // --- FIN CAPA TEMPORAL PYMES ---

      let dataResp = Array.isArray(data) ? data[0] : data;
      let suma = sumarValoresTotales(data);

      if (dataResp.transaccion) {
        setTotal(suma);
        setErrorCalular(false);
        setMensajeErrorCalcular('');
      } else {
        setErrorCalular(true);
        setMensajeErrorCalcular(dataResp.mensaje || 'Error al calcular totales');
      }
    } catch (error) {
      console.error('Error en calcularTotales:', error);
      setErrorCalular(true);
      setMensajeErrorCalcular('Ocurrió un problema con el servicio. Por favor, contacte a soporte técnico.');
    } finally {
      if (setLoading && typeof setLoading === 'function') {
        setLoading(false);
      }
    }
  }, [dataRenovacion, esPymes, setLoading]);


  useEffect(() => {
    if (paso === "datos-facturacion") {
      // Para PYMES, calcular desde el endpoint (trae impuestos desglosados)
      if (esPymes && dataRenovacion && dataRenovacion._id) {
        calcularTotales("");
        return;
      }
      // Para otros ramos (vehículos), usar los totales que vienen del carrito
      if (valoresTotales) {
        setTotal({
          primaNeta: valoresTotales.primaNeta || 0,
          prima_neta_anual_full_cobertura: valoresTotales.primaNeta || 0,
          super_bancos_Full_Cobertura: getImpuestoValor(valoresTotales.impuestos, "Superintendencia"),
          seguro_campesino_Full_Cobertura: getImpuestoValor(valoresTotales.impuestos, "Seguro Campesino"),
          derecho_emision_Full_Cobertura: getImpuestoValor(valoresTotales.impuestos, "Derecho"),
          iva_Full_Cobertura: getImpuestoValor(valoresTotales.impuestos, "IVA"),
          primaTotal_Full_Cobertura: valoresTotales.primaTotal || 0,
          totalImpuestos: valoresTotales.totalImpuestos || 0,
        });
      }
      return;
    }

    const codigo = planSeleccionado ? planSeleccionado.codigo : "";
    calcularTotales(codigo);
    // eslint-disable-next-line
  }, [valoresTotales, paso, esPymes]);

  const getImpuestoValor = (impuestos, nombreClave) => {
    if (!impuestos || !Array.isArray(impuestos)) return 0;
    const impuesto = impuestos.find(imp => imp.nombre && imp.nombre.includes(nombreClave));
    return impuesto ? impuesto.valor : 0;
  };


  const validarSiniestralidad = async (idRenovacion) => {
    if (setLoading && typeof setLoading === 'function') {
      setLoading(true, "Validando siniestralidad...");
    }
    try {
      if (!idRenovacion) return { transaccion: false, mensaje: 'No se generó un identificador de renovación válido.' };
      const url = `${urlObtenerSiniestralidad}&idRenovacion=${idRenovacion}`;
      const data = await httpClient.get(url);
      if (data && data.transaccion === false) {
        return { transaccion: false, mensaje: data.mensaje || 'La validación de siniestralidad no fue exitosa. Por favor, verifique el estado del cliente.' };
      }
      return data;
    } catch (error) {
      console.error('Error en validarSiniestralidad:', error);
      return { transaccion: false, mensaje: 'Ocurrió un problema técnico al validar la siniestralidad.' };
    } finally {
      if (setLoading && typeof setLoading === 'function') {
        setLoading(false);
      }
    }
  };

  const obtenerCodigoEspecial2 = (prod) => {
    switch (prod) {
      case 'AIGAUTO': return 'comparador';
      case 'PRACTIAUTO': return 'pits';
      default: return 'externo';
    }
  };

  const obtenerCodigoEspecial = (prod) => {
    switch (prod) {
      case 'AIG AUTO': return 'comparador';
      case 'PRACTIAUTO': return 'pits';
      default: return '';
    }
  };

  const renovarPoliza = async (numeroPolizaEmision, anio, renovar, id) => {
    setLoading(true);
    const yearVariable = parseInt(anio);
    const difference = moment().year() - yearVariable;
    const bloquearFullCobertura = difference >= 15;

    // Flujo PYMES
    if (esPymes) {
      const resultSiniestralidad = await validarSiniestralidad(id);
      if (resultSiniestralidad.transaccion === false) {
        setErrorRenovaciones(true);
        setMensajeErrorRenovaciones(resultSiniestralidad.mensaje);
        setLoading(false);
        return;
      }
      history.push({ pathname: "/datos-facturacion-pymes", search: `?renovacionId=${id}` });
      setLoading(false);
      return;
    }

    // Flujo Auto/Otros
    const codigoPlan = planSeleccionado ? planSeleccionado.codigo : "";
    let url = `${urlGuardarRenovaciones}${numeroPolizaEmision}&producto=${codigoPlan}&renovacionId=${id}`;
    let body = { emailAsesor: (dataUsuario && dataUsuario.correo) || '' };
    const data = await httpClient.post(url, body);

    if (data.transaccion) {
      history.push({
        pathname: "/resumen-cotizacion-renovacion",
        search: `?id=${data.data.idCarrito}${dataRenovacion.noPortal === true ? '&esNoPortal=true' : ''}&paso=resumen&codigoProductoEspecial=${obtenerCodigoEspecial2(codigoPlan)}${renovar ? '&esRenovacion=true' : ''}${renovar && bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`
      });
    } else {
      setErrorRenovaciones(true);
      setMensajeErrorRenovaciones(data.data.producto);
    }
    setLoading(false);
  };

  const onClickContinuar = async (numeroPolizaEmision, anio, renovar, id) => {
    setIsConfirmOpen(true);
    setMessage(`¿Estás seguro de iniciar la gestión de ${renovar ? 'renovación' : 'recotización'}?`);
    setConfirmAction(() => () => renovarPoliza(numeroPolizaEmision, anio, renovar, id));
  };

  const onClickContinuarProceso = async (idCarrito, anio, prod) => {
    const difference = moment().year() - parseInt(anio);
    const bloquearFullCobertura = difference >= 15;
    history.push({
      pathname: "/resumen-cotizacion-renovacion",
      search: `?id=${idCarrito}${dataRenovacion.noPortal === true ? '&esNoPortal=true' : ''}&paso=resumen&codigoProductoEspecial=${prod}&esRenovacion=true${bloquearFullCobertura ? '&bloquearFullCobertura=true' : ''}`
    });
  };

  const convertirANumero = (s) => {
    if (!s) return "0.00";
    try {
      let numero = parseFloat(s);
      if (isNaN(numero)) throw new Error("Valor no numérico");
      return numero.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    } catch (error) {
      return "0.00";
    }
  };

  const itemTemplate = (option) => (
    <div className='container w-100' style={{ width: "100%", borderRadius: "4px", lineHeight: "15px", paddingTop: 10, paddingBottom: 10 }} key={option.codigo}>
      <small style={{ fontSize: "10px" }}>{option.plan}</small>
    </div>
  );

  const onChangeItem = ({ value }) => {
    if (value && value.codigo) {
      setPlanSeleccionado(value);
      calcularTotales(value.codigo);
    }
  };

  return (
    <div>
      <div>
        {(validarBotonRenovar(dataRenovacion) && planes.length > 1 && !esPymes) && (
          <Card style={{ width: "99%" }}>
            <CardHeader><strong>Selecciona un producto</strong></CardHeader>
            <CardBody>
              <div>
                <Form>
                  {planes != null && (
                    <SelectButton
                      value={planSeleccionado}
                      disabled={disabled}
                      options={planes}
                      onChange={onChangeItem}
                      optionLabel='codigo'
                      itemTemplate={itemTemplate}
                      className='vertically w-100'
                      dataKey='codigo'
                    />
                  )}
                </Form>
              </div>
            </CardBody>
          </Card>
        )}

        <Card style={{ width: "99%" }}>
          {((codigoProductoEspecial && codeProductoEspecial !== "KilometrosConsumidos" && planes != null && planes.length > 0)) && (
            <CardHeader><strong>Resumen</strong></CardHeader>
          )}
          <CardBody>
            <div>
              {((codigoProductoEspecial && codeProductoEspecial !== "KilometrosConsumidos" && planes != null && planes.length > 0)) && (
                <div>
                  <Form style={{ width: "99%" }}>
                    {planes != null && (
                      <SelectButton
                        value={planSeleccionado}
                        disabled={disabled}
                        options={planes}
                        onChange={onChangeItem}
                        optionLabel='codigo'
                        itemTemplate={itemTemplate}
                        className='vertically w-100 my-3'
                        dataKey='codigo'
                      />
                    )}
                  </Form>
                </div>
              )}
            </div>

            <div>
              <h4 style={{ fontWeight: "bold" }}>Valor del Seguro</h4>
              <Row>
                <Col lg={6} md={6} sm={6} xs={6}><h5 style={{ fontWeight: "bold" }}>Prima Neta</h5></Col>
                <Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.primaNeta || total.prima_neta_anual_full_cobertura)}</h5></Col>
              </Row>

              <Row>
                <div id='container-imp'>
                  <div className='accordion-imp'>
                    <input type='checkbox' id='tm' />
                    <label htmlFor='tm' className='accordionitem'>
                      <Row>
                        <Col lg={6} md={6} sm={6} xs={6}><h5 title={"Presiona click para ver/ocultar el detalle impuestos"}>Impuestos <i className='fa fa-info-circle' aria-hidden='true' /></h5></Col>
                        <Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.totalImpuestos)}</h5></Col>
                      </Row>
                    </label>
                    <div className='hiddentext ocultar'>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>IVA</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.iva_Full_Cobertura)}</h5></Col></Row>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>Super bancos 3.5 %</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.super_bancos_Full_Cobertura)}</h5></Col></Row>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>Seguro Campesino</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.seguro_campesino_Full_Cobertura)}</h5></Col></Row>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>Derechos de Emisión</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.derecho_emision_Full_Cobertura)}</h5></Col></Row>
                    </div>
                  </div>
                </div>
              </Row>

              <Row>
                <div id='container-imp'>
                  <div className='accordion-imp'>
                    <input type='checkbox' id='tm' />
                    <label htmlFor='tm' className='accordionitem'>
                      <Row>
                        <Col lg={6} md={6} sm={6} xs={6}><h5 title={"Presiona click para ver/ocultar el detalle impuestos"}>Impuestos <i className='fa fa-info-circle' aria-hidden='true' /></h5></Col>
                        <Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.totalImpuestos)}</h5></Col>
                      </Row>
                    </label>
                    <div className='hiddentext ocultar'>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>IVA</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.iva_Full_Cobertura)}</h5></Col></Row>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>Super bancos 3.5 %</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.super_bancos_Full_Cobertura)}</h5></Col></Row>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>Seguro Campesino</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.seguro_campesino_Full_Cobertura)}</h5></Col></Row>
                      <Row><Col lg={6} md={6} sm={6} xs={6}><h5>Derechos de Emisión</h5></Col><Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.derecho_emision_Full_Cobertura)}</h5></Col></Row>
                    </div>
                  </div>
                </div>
              </Row>

              <Row>
                <Col lg={6} md={6} sm={6} xs={6}><h5 style={{ fontWeight: "bold" }}>Prima Total</h5></Col>
                <Col lg={6} md={6} sm={6} xs={6}><h5>${convertirANumero(total.primaTotal_Full_Cobertura)}</h5></Col>
              </Row>

              <Row>
                <Col lg={12} md={12} sm={12} xs={12}>
                  <hr />
                  {paso !== "datos-facturacion" && (
                    <>
                      {validarBotonRenovar(dataRenovacion) && !errorCalular && (
                        <Button
                          className={"btn btn-primary"}
                          onClick={() => onClickContinuar(dataRenovacion.numeroPolizaEmision, dataRenovacion.anio, true, dataRenovacion._id)}
                          style={{ display: "block", margin: "auto" }}>
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" /> {'Gestionar renovación'}
                        </Button>
                      )}

                      {(dataRenovacion.estado === 'EN_PROCESO' && !errorCalular) && (
                        <Button
                          className={"btn btn-primary"}
                          onClick={() => onClickContinuarProceso(dataRenovacion.reIdCarrito, dataRenovacion.anio, dataRenovacion.reProductoNuevo)}
                          style={{ display: "block", margin: "auto" }}>
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" /> {'Continuar'}
                        </Button>
                      )}

                      {(dataRenovacion.estado === 'VENCIDAS') && (
                        <Button
                          className={"btn btn-primary"}
                          onClick={() => onClickContinuar(dataRenovacion.numeroPolizaEmision, dataRenovacion.anio, false, obtenerCodigoEspecial(dataRenovacion.polDescripcionSeguro), planSeleccionado ? planSeleccionado.codigo : '')}
                          style={{ display: "block", margin: "auto" }}>
                          <i className="fa fa-chevron-circle-right" aria-hidden="true" /> {'Crear carrito'}
                        </Button>
                      )}

                      {(dataRenovacion.estado === 'NO_RENOVADAS') && (
                        <p>{dataRenovacion.mensajeNoRenovables}</p>
                      )}
                    </>
                  )}

                  {paso === "datos-facturacion" && (
                    <div style={{ marginTop: 20 }}>
                      <table style={{ margin: "auto" }}>
                        <tbody>
                          <tr>
                            <td>
                              <Checkbox
                                id={"terminosycondiciones"}
                                name={"terminosycondiciones"}
                                onBlur={() => { }}
                                checked={terminosHabilitado}
                                onChange={(terminosHabilitado, e) => {
                                  setTerminosHabilitado(terminosHabilitado);
                                }}
                                validationOption={{
                                  name: "terminosycondiciones",
                                  check: true,
                                  required: true
                                }}
                              />
                            </td>
                            <td>
                              <a className="btn-color-main" title="Ver Términos y Condiciones" href={dataUsuario && dataUsuario.disclaimerUrl ? dataUsuario.disclaimerUrl : "#"} target="_blank" rel="noopener noreferrer">
                                <h6 style={{ marginTop: "0.4em" }}> Aceptar Términos y Condiciones </h6>
                              </a>
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <hr />
                      <Button
                        className={"btn btn-primary"}
                        onClick={validarFormulario || (() => { })}
                        style={{ display: "block", margin: "auto" }}
                        disabled={!terminosHabilitado}
                      >
                        <i className="fa fa-chevron-circle-right" aria-hidden="true" />{" "}
                        {"CONTINUAR"}
                      </Button>
                    </div>
                  )}

                  <br />
                </Col>
              </Row>
            </div>
          </CardBody>
        </Card>

        {errorCalular && (
          <Alert color='danger' isOpen={true} toggle={() => setErrorCalular(false)}>
            <center><p>{mensajeErrorCalcular}</p></center>
          </Alert>
        )}
        {errorRenovaciones && (
          <Alert color='danger' isOpen={true} toggle={() => setErrorRenovaciones(false)}>
            <center><p>{mensajeErrorRenovaciones}</p></center>
          </Alert>
        )}

        {props.validationError && paso === "datos-facturacion" && (
          <Alert color={props.validationErrorType || "warning"} className="mt-3 mb-0" style={{ textAlign: "center" }}>
            <i className={"fa " + (props.validationErrorType === "danger" ? "fa-times-circle" : "fa-exclamation-triangle")} style={{ marginRight: 6 }} />
            {props.validationError}
          </Alert>
        )}
      </div>

      <ConfirmDialog
        isOpen={isConfirmOpen}
        toggle={() => setIsConfirmOpen(!isConfirmOpen)}
        message={message}
        onConfirm={() => { if (confirmAction) confirmAction(); }}
      />
    </div>
  );
};

const mapStateToProps = (state) => ({
  dataUsuario: (state.datosUsuarios && state.datosUsuarios.dataUsuario) || {}
});

export default withRouter(connect(mapStateToProps, null)(ValoresRenovacion));